// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/layoutEdit/drop/drop.js#1 $
'use strict';

angular.module('tcApp')
.directive('tcDrop', function() {
	return {
		restrict: 'E',
		replace: true,
		scope: {
			'tcIndex': '=',
			'tcType': '@',
			'tcArray': '=',
			'tcState': '=',
			'tcNestedLevel': '=',
			'tcAfterDrop': '&',
			'tcAllowDrop': '&',
			'tcDropElementId': '@'
		},
		templateUrl: 'template/layoutEdit/drop/drop.html',
		link: function(scope, element, attrs) {
			scope.isHeaderBar = (angular.isDefined(attrs.tcDropHeaderBar));
			scope.isButtonBar = (angular.isDefined(attrs.tcDropButtonBar));
			scope.viewModel = {
				isActiveHover: false
			};
			
			scope.isVisible = function() {
				if (angular.isUndefined(scope.tcArray)) scope.tcArray = [];
				var displayType;
				var selectedItem = null;
				if (scope.tcState.selected.array) {
					selectedItem = scope.tcState.selected.array[scope.tcState.selected.index];
				}
				
				// For button bar, only allow item types of link or button
				if ((scope.isButtonBar) && (selectedItem)) {
					displayType = selectedItem.displayType;
					if ((scope.tcState.selected.type !== 'column')
						&& (scope.tcState.selected.type !== 'tableItemRef')
						&& ((displayType === 'A') || (displayType === 'B'))) {
						return true;
					} else {
						return false;
					}
				}
				// For header bar, only allow item types of link, button or checkbox
				if ((scope.isHeaderBar) && (selectedItem)) {
					displayType = selectedItem.displayType;
					if ((scope.tcState.selected.type !== 'column')
						&& (scope.tcState.selected.type !== 'tableItemRef')
						&& ((displayType === 'A') || (displayType === 'B') || (displayType === 'C'))) {
						return true;
					} else {
						return false;
					}
				}
				// Prevent moving one block structure into another to circumvent the maximum block level
				if ((scope.tcState.selected.blockLevel) && (scope.tcNestedLevel) &&
				((scope.tcState.selected.blockLevel + scope.tcNestedLevel) > 4)) return false;
				
				if (scope.tcAllowDrop() === false) return false;
				
				return ((',' + scope.tcType + ',').indexOf((',' + scope.tcState.selected.type + ',')) !== -1)  &&
					(!scope.tcArray[scope.tcIndex] || !scope.tcArray[scope.tcIndex].selected) &&
					(!scope.tcArray[scope.tcIndex - 1] || !scope.tcArray[scope.tcIndex - 1].selected);
			};

			scope.drop = function($event, isPreview) {
				if (!scope.tcState.selected.array) return true;
				if ((',' + scope.tcType + ',').indexOf((',' + scope.tcState.selected.type + ',')) === -1) return true;

				var item = scope.tcState.selected.array[scope.tcState.selected.index];
				item.selected = false;
				var dropType = scope.tcState.selected.type;
				var isToolbox = (scope.tcState.selected.isToolbox === 'true');
				
				// Dropping from the toolbox
				if ((isToolbox) || (dropType === 'button')) {
					item = angular.copy(item);
					if ((!scope.isButtonBar)
						&& (!scope.isHeaderBar)
						&& ((dropType === 'row')
						|| (dropType === 'button'))
						&& (angular.isUndefined(item.itemRefs))) {
						item = {itemRefs: [item]};
					}
					if (dropType === 'column') {
						if (item.dynamicColumn) {
							item = {'dynamicColumn': item.name};
						} else if (angular.isUndefined(item.columnRows)) {
							item = {columnRows: [{tableItemRefs: [item]}]};
						}
					}
					if (dropType === 'room') {
						item = {room: item.name.substr(4), roomQuery: item.roomQuery};
					}
				}
				// Wrap items in a row if necessary
				if (((',' + scope.tcType + ',').indexOf(',row,') !== -1)
					&& (dropType === 'toolboxItem')) {
					item = {itemRefs: [item]};
				}
				var index = scope.tcIndex;
				if ((scope.tcState.selected.array == scope.tcArray) && (scope.tcState.selected.index < scope.tcIndex)) {
					index--;
				}
				if (!isToolbox) {
					scope.tcState.selected.array.splice(scope.tcState.selected.index, 1);
				}
				scope.tcArray.splice(index, 0, item);
				if (isPreview) {
					scope.tcState.selected.isToolbox = false;
					scope.tcState.selected.array = scope.tcArray;
					scope.tcState.selected.index = index;
					item.selected = true;
				} else {
					scope.tcState.selected = {};
				}
				scope.tcAfterDrop({dropType: dropType, isToolbox: isToolbox});
				$event.stopPropagation();
			};
			
			scope.dropMouseOver = function() {
				scope.viewModel.isActiveHover = true;
			};
			scope.dropMouseOut = function() {
				scope.viewModel.isActiveHover = false;
			};

			var onDrop = function($event) {
				scope.$apply(scope.drop($event));
			};
			element.on('drop', onDrop);

			var onDragover = function($event) {
				if ($event.preventDefault) $event.preventDefault(); // allows us to drop
				scope.$apply(scope.drop($event, true));
				return true;
			};
			element.on('dragover', onDragover);
			
			scope.$on('$destroy', function() {
				element.off('drop', onDrop);
				element.off('dragover', onDragover);
			});
		}
	};
});
